import React from "react";
import { useDispatch } from "react-redux";
// import { useHistory } from "react-router-dom";

import { ALERT } from "../constants/actionTypes";

// import { approvePayment } from "../utils/approvePayment";

import { PaystackButton } from "react-paystack";

const Paystack = ({ id, email, price, urgent }) => {
  const dispatch = useDispatch();
  // const history = useHistory();

  const config = {
    email,
    amount: Math.ceil(price * 100),
    publicKey: process.env.REACT_APP_PAYSTACK_KEY,
  };

  const handlePaystackSuccessAction = async (result) => {
    // const payment = {
    //   reference: result.reference,
    //   date: new Date(),
    //   gateway: "paystack",
    //   amount: Math.ceil(price * 100),
    //   email,
    // };
    // approvePayment(
    //   id,
    //   payment,
    //   dispatch,
    //   history,
    //   urgent,
    //   Math.ceil(price * 100)
    // );
  };

  const handlePaystackCloseAction = () => {
    dispatch({
      type: ALERT,
      payload: {
        severity: "warning",
        message: "Transaction cancelled",
        duration: 5000,
        display: true,
      },
    });
  };

  const componenetProps = {
    ...config,
    text: "PayStack",
    onSuccess: (reference) => handlePaystackSuccessAction(reference),
    onClose: handlePaystackCloseAction,
  };

  return (
    <PaystackButton
      className="border-0 outline-0 p-10 mt-40 italics"
      {...componenetProps}
    />
  );
};

export default Paystack;
